export function csvEscape(value) {
  const s = String(value ?? '');
  return `"${s.replace(/"/g, '""')}"`;
}

export function downloadCsv(filename, rows) {
  const keys = [...new Set(rows.flatMap((row) => Object.keys(row || {})))];
  const lines = [
    keys.map(csvEscape).join(','),
    ...rows.map((row) => keys.map((k) => csvEscape(row?.[k])).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
